import React, { useRef, useState, useEffect } from "react";
import { useNavigate,Link  } from "react-router-dom";
import Lottie from "lottie-react";
import MazeMAnimation from "../game/crazy/MazeMAnimation_fixed.json";
import FloatingParticles from "../game/crazy/FloatingParticles";
import Planet from "../game/crazy/Planet";
import Rocket from "../game/crazy/Rocket";
import PageWrapper from "../game/crazy/PageWrapper";
import LineRevealTransition  from "../game/crazy/LineRevealTransition";
import WavyText from "../game/crazy/WavyText";







export default function LandingScreen() {
  const navigate = useNavigate();
  const [soundEnabled, setSoundEnabled] = useState(false);
  const [hideFloating, setHideFloating] = useState(false);
  const audioRef = useRef(null);

  // ✅ Unlock audio after any first click on page
  useEffect(() => {
    const unlockAudio = () => {
      setSoundEnabled(true);
      window.removeEventListener("click", unlockAudio);
    };
    window.addEventListener("click", unlockAudio);
  }, []);

  const [startWipe, setStartWipe] = useState(false);


const handleStart = () => {
  setStartWipe(true);
};




  

  const handleMysteryHover = () => {
    setHideFloating(true);
    if (soundEnabled && audioRef.current) {
      audioRef.current.currentTime = 0;
      audioRef.current.play().catch(() => {});
    }
  };

  const handleMysteryLeave = () => {
    setHideFloating(false);
  };

  return (
    <>
    <PageWrapper>
    <div className="relative h-screen w-screen overflow-hidden text-white">
      {/* 🌄 Background Gradient */}
      <div className="absolute inset-0 z-0 bg-gradient-to-b from-indigo-900 via-purple-800 to-pink-600" />

      {/* 🔊 Hidden audio element */}
      <audio ref={audioRef} src="audio/magic-spell.mp3" preload="auto" />

      {/* 🔇/🎵 Sound Toggle Button */}
     {/* 🔇 / 🎵 Floating-style sound toggle */}
<span
  onClick={() => setSoundEnabled(!soundEnabled)}
  className="absolute top-6 right-6 z-40 text-2xl cursor-pointer select-none text-white"
  style={{
    filter: "drop-shadow(0 0 2px rgba(255,255,255,0.2))",
    transition: "transform 0.3s ease-in-out",
  }}
>
  {soundEnabled ? "🔊" : "🔇"}
</span>


      {/* ✨ Floating Particles */}
      {!hideFloating && <FloatingParticles />}

      {/* 🏔️ Mountains Layer */}
      <div className="absolute bottom-0 left-0 right-0 z-10 pointer-events-none">
        <svg className="absolute bottom-0 w-full h-64" viewBox="0 0 1200 200" preserveAspectRatio="none">
          <path d="M0,200 L0,100 Q200,60 400,80 Q600,50 800,90 Q1000,40 1200,70 L1200,200 Z" fill="rgba(253, 186, 116, 0.15)" filter="blur(0.5px)" />
        </svg>
        <svg className="absolute bottom-0 w-full h-48" viewBox="0 0 1200 150" preserveAspectRatio="none">
          <path d="M0,150 L0,80 Q150,40 300,60 Q450,30 600,70 Q750,20 900,50 Q1050,40 1200,60 L1200,150 Z" fill="rgba(253, 186, 116, 0.15)" />
        </svg>
        <svg className="absolute bottom-0 w-full h-32" viewBox="0 0 1200 100" preserveAspectRatio="none">
          <path d="M0,100 L0,60 Q100,20 200,40 Q300,10 400,50 Q500,30 600,45 Q700,25 800,40 Q900,20 1000,35 Q1100,25 1200,40 L1200,100 Z" fill="#fb7185" style={{ filter: "drop-shadow(0 -2px 3px rgba(0,0,0,0.1))" }} />
        </svg>
      </div>

      {/* 🧠 Foreground Content */}
      <div className="relative z-10 min-h-screen w-full flex flex-col items-center justify-center px-4 text-white">
        <Lottie
          animationData={MazeMAnimation}
          loop={true}
          autoplay={true}
          className="w-72 h-72 mb-8 drop-shadow-xl"
        />

        {/* 🔝 Brand */}
        <div className="absolute top-4 left-6 sm:top-6 sm:left-8 z-20">
          <p className="text-2xl sm:text-3xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-yellow-300 via-pink-400 to-purple-500">
            MazeMoh
          </p>
        </div>

        {/* 🧾 Tagline */}
        <div className="mt-4 text-center px-4 max-w-xl">
          <p className="-translate-y-11 text-xl italic text-center text-white transform transition duration-300 glow-tagline">
            playful. personal.{" "}
            <span
              className="cursor-pointer transition-opacity duration-300"
              onMouseEnter={handleMysteryHover}
              onMouseLeave={handleMysteryLeave}
            >
              <WavyText text="little mysterious" />
            </span>
          </p>
        </div>

        {/* 🚀 CTA */}
        <div className="flex justify-center items-center mt-6 mb-36">
          <button
            onClick={handleStart}
            className="bg-gradient-to-r from-orange-400 to-red-500 text-white font-semibold py-2 px-6 rounded-full shadow-xl hover:scale-105 transition-transform duration-300"
          >
            🚀 Begin Your Quest
          </button>
        </div>

{/* 📱 Mobile-only Experience Notice */}
<div className="block sm:hidden text-center text-xs text-white/80 px-6 mb-16">
  <div className="bg-black/30 backdrop-blur-sm rounded-xl py-2 px-4 mx-auto max-w-xs">
    For the full MazeMoh experience — including Medium & Hard levels — try it on a larger screen! 💻🧠
  </div>
</div>

{/* 💖 Footer Section */}
<div className="absolute bottom-3 w-full px-4 flex flex-col sm:flex-row items-center justify-center sm:justify-between gap-1 text-sm z-30">
  <Link
    to="/credits"
    className="font-medium text-white hover:text-indigo-300 transition-colors underline"
  >
    Privacy and Credits
  </Link>

  <p className="font-medium text-white text-center">
    Made with 💖 by{" "}
    <a
      href="https://x.com/MrGorantla"
      target="_blank"
      rel="noopener noreferrer"
      className="underline hover:text-indigo-300"
    >
      Sai Vinod
    </a>
  </p>
</div>

      </div>
    </div>
    </PageWrapper>
    <LineRevealTransition
    isActive={startWipe}
    onMidway={() => navigate("/home")}
  />
   </> 
  );
}
